(function () {
  // FIX: Disable View Transitions on mobile to prevent black screen bug
  // on iOS Safari, Chrome mobile, and in-app browsers (Instagram etc.)
  // The combination of the sticky #ww-bar GPU layer (z-index:9999) and
  // the view-transition-name:sticky-header on the header causes compositor
  // conflicts that result in a solid black frame during page navigation.
  if (window.matchMedia('(max-width: 749px)').matches) {
    // On mobile: just remove the render blocker immediately and bail out
    const renderBlocker = document.getElementById('view-transition-render-blocker');
    if (renderBlocker) renderBlocker.remove();
    return;
  }

  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  // Remove the view transition render blocker if the user has reduced motion enabled
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    viewTransitionRenderBlocker?.remove();
  } else {
    // If the browser didn't manage to parse the main content quickly enough,
    // We're aiming for the FCP to be under 1.8 seconds since the page was requested.
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());

    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const viewTransition = /** @type {PageSwapEvent} */ (event).viewTransition;

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skip();
      return;
    }

    // Cancel view transition on user interaction to improve INP
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          /** @type {ViewTransition | null} */ (viewTransition)?.skip();
        },
        { once: true }
      );
    });
  });

  document.addEventListener('pagereveal', async (event) => {
    const viewTransition = /** @type {PageRevealEvent} */ (event).viewTransition;

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skip();
      return;
    }

    idleCallback(() => {
      document.documentElement.removeAttribute('data-view-transition');
    });
  });

  function shouldSkipViewTransition(viewTransition) {
    return (
      !viewTransition ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }
})();